import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Form,
  Card,
  Button,
  Input,
  Icon,
  FormField,
  Select,
  ModalContent,
  ModalActions,
  Modal,
  Loader,
  ModalDescription,
  Header,
} from 'semantic-ui-react'
import { toast } from 'react-toastify'

import { Container, LoadingContainer } from './styles'
import api from '../../services/api'

const options = [
  { key: '1', value: '1', text: 'Texto' },
  { key: '2', value: '2', text: 'Caixa de Seleção' },
  { key: '3', value: '3', text: 'Numero' },
  { key: '4', value: '4', text: 'CPF' },
  { key: '5', value: '5', text: 'RG' },
  { key: '6', value: '6', text: 'CNPJ' },
  { key: '7', value: '7', text: 'Celular' },
  { key: '8', value: '8', text: 'Regex' },
]

export default function TemplateFields() {
  const dispatch = useDispatch()

  const [openModalAddField, setOpenModalAddField] = useState(false)
  const [openModalRemoveField, setOpenModalRemoveField] = useState(false)
  const [openModalAddOption, setOpenModalAddOption] = useState(false)
  const [openModalRemoveOption, setOpenModalRemoveOption] = useState(false)

  const [nomeCampoDeletar, setNomeCampoDeletar] = useState('')
  const [idCampoDeletar, setIdCampoDeletar] = useState(0)

  const [novaOpcao, setNovaOpcao] = useState('')
  const [idCampoSelect, setIdCampoSelect] = useState(0)

  const [nomeOpcaoRemover, setNomeOpcaoRemover] = useState('')
  const [idOpcaoRemover, setIdOpcaoRemover] = useState(0)

  const [nomeCampo, setNomeCampo] = useState('')
  const [tipoCampo, setTipoCampo] = useState('1')
  const [campoRegex, setCampoRegex] = useState('')
  const [contactFields, setContactFields] = useState([])
  const [loading, setLoading] = useState(false)

  const profile = useSelector((state) => state.user.profile)
  const contato = useSelector((state) => state.contato)

  const [opcaoSelecionada, setOpcaoSelecionada] = useState(0)

  const getContactFields = useCallback(async () => {
    try {
      setLoading(true)

      const { data } = await api.get(`templatefields/${profile.id_dominio}`)
      setContactFields(data)
    } catch (error) {
      toast.error('Erro ao carregar campos personalizados')
    } finally {
      setLoading(false)
    }
  }, [profile.id_dominio])

  useEffect(() => {
    getContactFields()
  }, [getContactFields])

  const handleAddField = useCallback(async () => {
    try {
      if (!nomeCampo || !tipoCampo) {
        toast.error('Por favor, preencha todos os campos obrigatórios.')
        return
      }

      if (tipoCampo === '8' && !campoRegex) {
        toast.error('Por favor, preencha o campo de Regex.')
        return
      }

      const { data } = await api.post('/templatefields', {
        name: nomeCampo,
        id_dominio: profile.id_dominio,
        tipo: tipoCampo,
        regex: campoRegex,
      })

      setOpenModalAddField(false)
      setNomeCampo('')
      setTipoCampo('1')
      setCampoRegex('')
      toast.success(`Campo ${data.nome_campo} adicionado com sucesso`)
      getContactFields()
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.error)
      } else {
        toast.error('Erro ao adicionar campo do template')
      }
    }
  }, [nomeCampo, tipoCampo, campoRegex, profile.id_dominio, getContactFields])

  const handleDeleteField = useCallback(async () => {
    try {
      const { data } = await api.delete(`templatefields/${idCampoDeletar}`)
      toast.success(`${data.message}`)
      setOpenModalRemoveField(false)
      setNomeCampoDeletar('')
      setIdCampoDeletar(0)
      getContactFields()
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.error)
      } else {
        toast.error('Erro ao remover campo do template')
      }
    }
  }, [getContactFields, idCampoDeletar])

  const handleAddSelectOption = useCallback(async () => {
    try {
      if (!novaOpcao || !idCampoSelect) {
        toast.error('Por favor, preencha todos os campos obrigatórios.')
        return
      }

      await api.post(
        `/domain/${profile.id_dominio}/templatefields/${idCampoSelect}/values`,
        {
          valor: novaOpcao,
        },
      )
      toast.success('Item adicionado com sucesso')
      setOpenModalAddOption(false)
      setNovaOpcao('')
      setIdCampoSelect(0)
      getContactFields()
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.error)
      } else {
        toast.error('Erro ao adicionar opção ao campo de seleção')
      }
    }
  }, [idCampoSelect, novaOpcao, profile.id_dominio, getContactFields])

  const handleRmSelectOption = useCallback(async () => {
    try {
      if (!idCampoDeletar || !idOpcaoRemover) {
        toast.error('Por favor, selecione um campo e uma opção para remover.')
        return
      }

      await api.delete(
        `/domain/${profile.id_dominio}/templatefields/${idCampoDeletar}/values/${idOpcaoRemover}`,
      )
      toast.success('Opção removida com sucesso')
      setOpenModalRemoveOption(false)
      setNomeOpcaoRemover('')
      setIdOpcaoRemover(0)
      setIdCampoDeletar(0)
      getContactFields()
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.error)
      } else {
        toast.error('Erro ao remover opção do campo de seleção')
      }
    }
  }, [getContactFields, idCampoDeletar, idOpcaoRemover, profile.id_dominio])

  if (loading) {
    return (
      <LoadingContainer>
        <Loader active inline="centered" />
      </LoadingContainer>
    )
  }

  return (
    <Container>
      <Card>
        <Card.Content>
          <Button
            icon
            labelPosition="left"
            primary
            size="small"
            onClick={() => {
              // handleAddField()
              setOpenModalAddField(true)
            }}
          >
            <Icon name="plus" /> Adicionar campo
          </Button>
        </Card.Content>
        <Card.Content>
          <Form>
            <Form.Group className="fields_personalizados">
              {contactFields?.map((field) => {
                if (field.tipo === 1) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'Texto'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 2) {
                  return (
                    <div className="select-button" key={field.nome_campo}>
                      <FormField
                        className="field2"
                        control={Select}
                        fluid
                        label={field.nome_campo}
                        options={[
                          ...field.template_fields_values.map((item) => {
                            return {
                              key: item.id,
                              text: item.valor,
                              value: item.id,
                            }
                          }),
                        ]}
                        value={opcaoSelecionada}
                        onChange={(e, { value }) => setOpcaoSelecionada(value)}
                        placeholder={'Campo de Seleção'}
                      />

                      <div className="buttons">
                        <Button
                          icon
                          onClick={() => {
                            setIdCampoSelect(field.id)
                            setOpenModalAddOption(true)
                            setNovaOpcao('')
                          }}
                        >
                          <Icon name="plus" />
                        </Button>

                        {opcaoSelecionada > 0 &&
                          field.template_fields_values.find(
                            (item) => item.id === opcaoSelecionada,
                          ) && (
                            <Button
                              icon
                              onClick={() => {
                                setOpenModalRemoveOption(true)
                                setIdCampoDeletar(field.id)
                                setIdOpcaoRemover(opcaoSelecionada)
                                setNomeOpcaoRemover(
                                  field.template_fields_values.find(
                                    (item) => item.id === opcaoSelecionada,
                                  ).valor,
                                )
                              }}
                            >
                              <Icon name="minus" />
                            </Button>
                          )}

                        <Button
                          icon
                          color="red"
                          onClick={() => {
                            setNomeCampoDeletar(field.nome_campo)
                            setIdCampoDeletar(field.id)
                            setOpenModalRemoveField(true)
                          }}
                        >
                          <Icon name="delete" />
                        </Button>
                      </div>
                    </div>
                  )
                }
                if (field.tipo === 3) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'Numero'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 4) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'CPF XXX.XXX.XXX-XX'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 5) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'RG XX.XXX.XXX-X'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 6) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'CNPJ XX.XXX.XXX/XXXX-XX'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 7) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={'Celular (XX) XXXXX-XXXX'}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
                if (field.tipo === 8) {
                  return (
                    <Form.Input
                      type="text"
                      key={field.nome_campo}
                      name={field.nome_campo}
                      fluid
                      label={field.nome_campo}
                      placeholder={field.nome_campo}
                      value={`Regex ${field.regex}`}
                      onChange={() => {}}
                      action={{
                        type: 'button',
                        color: 'red',
                        icon: 'delete',
                        onClick: () => {
                          setNomeCampoDeletar(field.nome_campo)
                          setIdCampoDeletar(field.id)
                          setOpenModalRemoveField(true)
                          // handleDeleteField(field.nome_campo, field.id)
                        },
                      }}
                    />
                  )
                }
              })}
            </Form.Group>
          </Form>
        </Card.Content>
      </Card>

      {/* Modal Add Field */}
      <Modal
        onClose={() => setOpenModalAddField(false)}
        onOpen={() => setOpenModalAddField(true)}
        open={openModalAddField}
        // trigger={<Button>Show Modal</Button>}
        size="tiny"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header icon="plus" content="Adicionar campo template" />
        <ModalContent>
          <Form>
            <FormField
              control={Input}
              label="Nome do Campo"
              placeholder="Nome do Campo"
              value={nomeCampo}
              onChange={(e) => setNomeCampo(e.target.value)}
              required
            />

            <FormField
              control={Select}
              label="Tipo de Campo"
              options={options}
              placeholder="Tipo de Campo"
              value={tipoCampo}
              onChange={(e, { value }) => setTipoCampo(value)}
              required
            />

            {tipoCampo === '8' && (
              <FormField
                control={Input}
                label="Regex de validação"
                placeholder="Regex de validação"
                value={campoRegex}
                onChange={(e) => setCampoRegex(e.target.value)}
                required
              />
            )}
          </Form>
        </ModalContent>
        <ModalActions>
          <Button
            color="black"
            onClick={() => {
              setOpenModalAddField(false)
              setNomeCampo('')
              setTipoCampo('1')
              setCampoRegex('')
            }}
          >
            Fechar
          </Button>
          <Button
            content="Adicionar"
            labelPosition="right"
            icon="plus"
            onClick={() => {
              handleAddField()
            }}
            positive
          />
        </ModalActions>
      </Modal>

      {/* Modal Remove Field */}
      <Modal
        onClose={() => setOpenModalRemoveField(false)}
        onOpen={() => setOpenModalRemoveField(true)}
        open={openModalRemoveField}
        // trigger={<Button>Show Modal</Button>}
        size="tiny"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        {/* <ModalHeader>Apagar campo: {nomeCampoDeletar}</ModalHeader> */}
        <Header
          icon="trash alternate"
          content={`Apagar campo: ${nomeCampoDeletar}`}
        />
        <ModalContent image>
          {/* <div className="image">
            <Icon name="trash alternate" />
          </div> */}
          <ModalDescription>
            <p>Tem certeza que deseja deletar ?</p>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button
            color="black"
            onClick={() => {
              setOpenModalRemoveField(false)
              setNomeCampoDeletar('')
              setIdCampoDeletar(0)
            }}
          >
            Cancelar
          </Button>
          <Button
            content="Remover"
            labelPosition="right"
            icon="minus"
            onClick={() => {
              handleDeleteField()
            }}
            negative
          />
        </ModalActions>
      </Modal>

      {/* Modal Adicionar Nova Opção */}
      <Modal
        onClose={() => setOpenModalAddOption(false)}
        onOpen={() => setOpenModalAddOption(true)}
        open={openModalAddOption}
        // trigger={<Button>Show Modal</Button>}
        size="tiny"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header icon="plus" content="Adicionar nova opção" />
        <ModalContent>
          <Form>
            <FormField
              control={Input}
              label="Nova Opção:"
              placeholder="Digite o nome da opção"
              value={novaOpcao}
              onChange={(e) => setNovaOpcao(e.target.value)}
              required
            />
          </Form>
        </ModalContent>
        <ModalActions>
          <Button
            color="black"
            onClick={() => {
              setOpenModalAddOption(false)
              setNovaOpcao('')
            }}
          >
            Cancelar
          </Button>
          <Button
            content="Adicionar"
            labelPosition="right"
            icon="plus"
            onClick={() => {
              handleAddSelectOption()
            }}
            positive
          />
        </ModalActions>
      </Modal>

      {/* Modal Remover Opção */}
      <Modal
        onClose={() => setOpenModalRemoveOption(false)}
        onOpen={() => setOpenModalRemoveOption(true)}
        open={openModalRemoveOption}
        // trigger={<Button>Show Modal</Button>}
        size="tiny"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header
          icon="trash alternate"
          content={`Apagar opção: ${nomeOpcaoRemover}`}
        />
        <ModalContent image>
          {/* <div className="image">
            <Icon name="trash alternate" />
          </div> */}
          <ModalDescription>
            <p>Tem certeza que deseja deletar ?</p>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button
            color="black"
            onClick={() => {
              setOpenModalRemoveOption(false)
              setNomeOpcaoRemover('')
              setIdOpcaoRemover(0)
              setIdCampoDeletar(0)
            }}
          >
            Cancelar
          </Button>
          <Button
            content="Remover"
            labelPosition="right"
            icon="minus"
            onClick={() => {
              handleRmSelectOption()
            }}
            negative
          />
        </ModalActions>
      </Modal>
    </Container>
  )
}
